<template>
  <main class="page_content" >
    <!-- <NavigationCard image="/assets/img/VIP/navigation.png" topUrl="../../../assets/img/TopFirst/NewsTop.mp4" topUrlType="video" title="SANMAK VIP CENTER" /> -->
    <section>
      <div class="align-content-center m-4">
        <div class="page_title" style="display: flex;justify-content: center;">
          <div class="page_title" style="display: flex;justify-content: center;">
            <div>
              <h3 class="page_title" style="display: inline-block;
          height: 4.1rem;
          border-bottom: 3px solid rgb(252, 180, 46); color: rgb(252, 180, 46);">News </h3>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="page_content">
      <div class="container row">
        <div class="text-left mt-5" v-html="content" ref="myDiv">
          <!-- <p class="card-text text-muted mb-4">
            {{ contentWithBreaks }}
          </p>
          <h6>1.Event Overview</h6>
          <p class="card-text text-muted mb-4">
            The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the
            largest automotive aftermarket trade shows in the world.It
          </p>
          <h6>2.Event Overview</h6>
          <p class="card-text text-muted mb-4">
            The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the
            largest automotive aftermarket trade shows in the world.It
          </p>
          <h6>3.Event Overview</h6>
          <p class="card-text text-muted mb-4">
            The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products Expo, is one of the
            largest automotive aftermarket trade shows in the world.It
          </p>
          <img class="card-img mb-4" src="../../assets/img/demo/1.jpg" alt="Card image">
          <p class="card-text text-muted mb-4">
            {{ contentWithBreaks }}
          </p> -->
        </div>

      </div>
      
      <div style="height: 50px;">
      </div>

    </section>
  </main>
</template>

<script>
  // import NavigationCard from '@/components/common/TopVideo.vue';
  import { getNewsAllList } from "@/api/rbac/news";
  export default {
    name: 'NewsDetails',
    components: {
      // NavigationCard,
    },
    computed: {
      contentWithBreaks() {
        return this.content.replace(/\\n/g, "\n");
      },
    },
    created() {
      this.getData()
    },
    data() {
      return {
        content: "The Las Vegas AAPEX Show, also known as the Automotive Aftermarket Products " +
          "Expo, is one of the largest automotive aftermarket trade shows in the world.It" +
          "brings together manufacturers, distributors, retailers, and service professionals" +
          "from the automotive aftermarket industry to showcase new peoducts, technologies and services." +
          "\n\n The Las Vegas AAPEX Show",
        slides: [
          { img: "https://via.placeholder.com/300x200?text=1", title: "Slide 1" },
          { img: "https://via.placeholder.com/300x200?text=2", title: "Slide 2" },
          { img: "https://via.placeholder.com/300x200?text=3", title: "Slide 3" },
        ],
        activeIndex: 0, // 当前激活的图片索引
      };
    },
    methods: {
      getData() {
        try {
          getNewsAllList({ tableType: this.$route.params.category, strWhere: ' and a.id=' + this.$route.params.id }).then((res) => {
            if (res.data.length == 0) {
              this.content = '';
            }
            else {
              this.content = res.data[0].content;
              this.content=this.content.replace(/<p>\s*<span\s+style="color:\s*black;">/gi, `<p><span style="color: white;">`);
              
            }

          });

        } catch (error) {
          console.log(error);
        }
      },
    },
  };
</script>

<style scoped>
  @import '../../assets/css/main.css';

  :deep(hr) {
    margin-top: 0.3rem;
    border-top: 1px solid #545454;
    margin-bottom: 0.3rem;
  }
</style>